'use strict'

import A11yDialog from 'a11y-dialog';

const modal = {
  currentModal: null,
  skipNextFocus: false,
  originalFocusTarget: null,
  originalScrollPosition: 0,
  modals: {},

  init(){
    const showListener = (dialogEl, event) => {
      const openedModal = this.modals[dialogEl.getAttribute('data-modal')];

      // Hide previous modal
      if (this.currentModal && this.currentModal !== openedModal) {
        this.currentModal.hide(event);
      }

      // Set active modal
      this.currentModal = openedModal;
      document.body.setAttribute('data-modal-open', dialogEl.getAttribute('data-modal'));

      // Load iframe when modal is opened
      const iframe = dialogEl.querySelector('iframe');
      if (iframe && (!iframe.src || iframe.hasAttribute('aria-hidden'))) {
        iframe.src = iframe.getAttribute('data-src');
        iframe.removeAttribute('aria-hidden');
      }
    };

    const hideListener = (dialogEl, event) => {
      this.currentModal = null;
      document.body.removeAttribute('data-modal-open');

      // Move focus to specific element after modal is closed
      if (!this.skipNextFocus && this.originalFocusTarget) {
        this.originalFocusTarget.focus();
        this.originalFocusTarget = null;
        window.scrollTo(0, this.originalScrollPosition);
      }
      this.skipNextFocus = false;
    };

    // Initialize modal instances
    const modals = document.querySelectorAll('[data-modal]');
    modals.forEach(modal => {
      const dialog = new A11yDialog(modal, 'body > *:not(script):not([data-modal])');
      dialog.on('show', showListener);
      dialog.on('hide', hideListener);
      this.modals[modal.getAttribute('data-modal')] = dialog;
    });

    // Open modal when toggle button is clicked
    const selectorAttributes = ['data-popup-toggle', 'data-dialog-toggle', 'data-modal-toggle'];
    selectorAttributes.forEach(attr => {
      const openListener = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const modal = this.modals[e.target.getAttribute(attr)];
        if (modal) {
          // Update dialog position
          if (modal.$el.getAttribute('data-modal-position') === 'trigger-top') {
            modal.$el.style.top = (e.target.getBoundingClientRect().top + window.scrollY) + 'px';
          }

          // Set original focus target
          if (!this.currentModal) {
            this.originalFocusTarget = e.target && e.target.focus ? e.target : null;
            this.originalScrollPosition = window.scrollY;
          }
          else {
            this.skipNextFocus = true;
          }

          modal.show(e);
        }
      };

      const toggles = document.querySelectorAll('[' + attr + ']');
      toggles.forEach(toggle => {
        toggle.addEventListener('click', openListener);
      });
    });

    // Hide modal when user clicks outside of modal
    document.addEventListener('click', (e) => {
      if (this.currentModal && !this.currentModal.$el.contains(e.target)) {
        this.currentModal.hide(e);
      }
    });
  }
}

module.exports = modal;
